module.exports = __webpack_public_path__ + "bg-2.png?652d32f8db1aaf3688bbb5b46f987ef7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-2.png
// module id = 83
// module chunks = 10